import {
  NetfondsConsentContext,
  NetfondsConsentEvent,
} from "../netfondsConsentSM";

export const addAccountsToContextAction = (
  context: NetfondsConsentContext,
  event: NetfondsConsentEvent
) => {
  if (event.type !== "IMPORT_DATA") return {};

  return {
    depots: event.depots,
    externalDepotIds: event.externalDepotIds?.length
      ? event.externalDepotIds
      : context.externalDepotIds,
  };
};
